import React from 'react';
import { Title } from '../style';
import CommandsReports from './CommandsReport/CommandsReports';

/**
 * Composant principale englobant toute la partie d'export de commande
 */
const ExportCommands = () => (
  <div>
    <Title>Export commandes</Title>
    <CommandsReports />
  </div>
);

export default ExportCommands;
